import React from 'react'
import "./style.css";

const Spinner = () => {
  return (
    <div>
      <span className="loader"></span>
    </div>
  )
}

export default Spinner
